module.exports = __webpack_public_path__ + "img/meunDetail10.2537e8a4.png";